// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStorePurchaseOrders = (client) => ({
    /**
     * `POST /store/purchase-orders/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePurchaseOrdersIdCancelCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/store/purchase-orders/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/purchase-orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePurchaseOrdersCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/purchase-orders", { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/purchase-orders/call-consent`
     *
     * @operationId StorePurchaseOrdersCallConsentRevoke
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/call-consent/route.ts
     */
    deleteCallConsent: (body, query, headers) => client.fetch("/store/purchase-orders/call-consent", { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/purchase-orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePurchaseOrdersList
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/route.ts
     */
    list: (query, headers) => client.fetch("/store/purchase-orders", { method: "GET", query, headers }),
    /**
     * `GET /store/purchase-orders/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePurchaseOrdersIdRetrieve
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/purchase-orders/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/purchase-orders/call-consent`
     *
     * @operationId StorePurchaseOrdersCallConsentGet
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/call-consent/route.ts
     */
    retrieveCallConsent: (query, headers) => client.fetch("/store/purchase-orders/call-consent", { method: "GET", query, headers }),
    /**
     * `POST /store/purchase-orders/checkout`
     *
     * @operationId StorePurchaseOrdersCheckoutCreate
     * @source packages/medusa-plugin-po-payment-v2/src/api/store/purchase-orders/checkout/route.ts
     */
    updateCheckout: (body, query, headers) => client.fetch("/store/purchase-orders/checkout", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=purchase-orders.js.map